import { Component } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { UserService } from '../../../services/core.user.service';

@Component({
    selector: 'not-found',
    template: `<div class="container-fluid welcome graphic-bg">
    <div class="row" style="min-height:480px;">
        <div class="col-xs-12 col-md-8">
            <div class="jumbotron intro-heading trans">
                <h1 class="text-primary">Not Found</h1>
                <p class="text-uppercase subhead text-muted" style="margin-top: 1em;">Sorry, could not find the URL you requested.</p>
                <p><a class="btn btn-lg btn-primary" uiSref="home">GForge Next Home<i class="glyphicon glyphicon-chevron-right" style="margin-left: .5em;"></i></a>
                    <a class="btn btn-lg btn-info"
                        *ngIf="userService.session.hasUser()"
                        uiSref="home.user.my" [uiParams]="{ unixName: userService.session.getUnixName() }"
                        style="margin-left: 2em;">Your Home Page<i class="glyphicon glyphicon-chevron-right" style="margin-left: .5em;"></i>
                    </a>
                </p>
            </div>
        </div>
    </div>
</div>`
})
export class NotFoundComponent {
    constructor(
        private stateService: StateService,
        protected userService: UserService,
    ) { }
}


